import { useMemo, useState } from 'react';

type ConfirmData = {
  callback: () => void;
  text?: string;
};

export const useConfirmClose = () => {
  const [data, setData] = useState<ConfirmData | null>(null);

  return useMemo(() => {
    return {
      data,
      hide: () => setData(null),
      confirm: (callback: () => void, text?: string) => setData({ callback, text }),
    };
  }, [data]);
};
